import AjaxService from '../services/ajax-service';
import { handleServerError } from 'shared-services/error-service';

export const fetchCustomFields = ({ projectId, limit, offset }) => {
    return AjaxService({
        method: 'get',
        url: 'fields',
        params: {
            project_id: projectId,
            limit,
            offset
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchCustomFieldsValues = (association, associationId) => {
    return AjaxService({
        method: 'get',
        url: `${association}s/${associationId}/fields`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createCustomField = ({ associations, associationId, fieldId, type, name, description, hidden, currency, options, cost_per_hour, tracking_type, in_library }) => {
    return AjaxService({
        method: 'post',
        url: `${associations[0]}s/${associationId}/fields`,
        data: {
            field_id: fieldId,
            type,
            name,
            description,
            roles: hidden,
            currency,
            options,
            cost_per_hour,
            tracking_type,
            save: in_library
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateCustomField = (customFieldId, { name, description, association, roles, currency, cost_per_hour, tracking_type, options }) => {
    return AjaxService({
        method: 'put',
        url: `fields/${customFieldId}`,
        data: {
            name,
            description,
            association,
            roles,
            currency,
            cost_per_hour,
            tracking_type,
            options
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeCustomField = customFieldId => {
    return AjaxService({
        method: 'delete',
        url: `fields/${customFieldId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const setCustomFieldValue = ({ association, associationId, fieldId, value }) => {
    return AjaxService({
        method: 'put',
        url: `${association}s/${associationId}/fields/${fieldId}`,
        data: { value }
    })
    .then(response => response.data)
    .catch(handleServerError);
}
